import { css } from "styled-components";

import { Palette } from "../../../../core/styles/theme";

export const formTabStyle = css`
    &.aevi-form-tab {
        width: fit-content;
        cursor: pointer;
        padding: 15px 0;
        font-size: 11pt;
        font-family: "AeviFont";
    }

    &.aevi-form-tab-active {
        border-bottom: 2px solid ${Palette.HeroGreen};
        font-size: 11pt;
        text-shadow: 0 0 0.25px currentcolor;
    }
`;
